import React, { useState } from "react";
import Escudo from "../../assets/img/escudo.svg";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { checkEmailValid } from "../../utils/validation";
import { usuariosUrl } from "../../serverURL";
import { SignIn } from "../../utils/auth";
import CheckEmail from "./CheckEmail";
import CheckPassword from "./CheckPassword";
import { usePartido } from "../../context/PartidoContext";

const LoginBox = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isVerificado, setIsVerificado] = useState(false);
  const [ingresoMail, setIngresoMail] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);

  const navigate = useNavigate();
  const { selectedPartido, setSelectedPartido } = usePartido();

  const validateEmail = (e) => {
    if (e.target?.value && checkEmailValid(e.target.value)) {
      setEmail(e.target.value);
    }
    return;
  };

  const handleEmailCheck = async () => {
    setIsLoading(true);

    const res = await fetch(usuariosUrl + "/check", {
      method: "POST",
      body: JSON.stringify({
        email,
      }),
    });

    const json = await res.json();

    if (json.exists) {
      setIsVerificado(true);
      setIngresoMail(true);
    } else {
      if (selectedPartido?.tipoAcreditacion === "fotografo") {
        localStorage.setItem("isF", "1");
        navigate("/login/formulario-fotografo");
      } else {
        localStorage.setItem("isNV", "1");
        navigate("/login/formulario-inicio");
      }
    }

    setIsLoading(false);
  };

  const handleLogin = async () => {
    setIsLoading(true);

    const res = await fetch(usuariosUrl + "/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });

    const json = await res.json();
    if (json.token) {
      const signInOptions = { isNV: false, isV: true};
      SignIn(json.token, signInOptions);
      if (selectedPartido) {
        navigate(`/acreditaciones/${selectedPartido.id}`);
      } else {
        navigate("/");
      }
    } else if (!isVerificado) {
      // For not verified users, set the localStorage flags without a token
      const signInOptions = { isNV: true, isV: false};
      SignIn(null, signInOptions );
    } else {
      setIsDisclaimerVisible(true);
    }

    setIsLoading(false);

    return json;
  };

  if (isLoading)
    return (
      <div className="login-box-wrapper">
        <div className="login-box">
          <img src={Escudo} alt="Escudo river plate" />
          <div className="login-loader-container">
            <ClipLoader />
          </div>
        </div>
      </div>
    );

  return (
    <div className="login-box-wrapper">
      <form className="login-box">
        <img src={Escudo} alt="Escudo river plate" />

        {!ingresoMail ? (
          <CheckEmail
            handleEmailCheck={handleEmailCheck}
            email={email}
            validateEmail={validateEmail}
          />
        ) : isVerificado ? (
          <CheckPassword
            handleLogin={handleLogin}
            isDisclaimerVisible={isDisclaimerVisible}
            password={password}
            setPassword={setPassword}
            email={email}
          />
        ) : null}
      </form>
    </div>
  );
};

export default LoginBox;
